export default function Input({
  label,
  error,
  helperText,
  type = 'text',
  className = '',
  ...props
}) {
  return (
    <div className="w-full">
      {label && <label className="input-label">{label}</label>}
      <input
        type={type}
        className={`input-field w-full ${error ? 'border-status-urgent' : ''} ${className}`}
        {...props}
      />
      {helperText && (
        <p className={`input-helper ${error ? 'error' : ''}`}>
          {error || helperText}
        </p>
      )}
    </div>
  )
}
